import { IfAbility } from '@efdigital/ll-addon-auth';
import type { TemplateOnlyComponent } from '@ember/component/template-only';

const LtiIntegrationsTemplate: TemplateOnlyComponent = <template>
  <IfAbility @ability="lti-integrations" @atLeast="viewer">
    <:if>
      {{outlet}}
    </:if>
    <:else>
      <div class="alert alert-warning">
        You do not have permission to view LTI integrations.
      </div>
    </:else>
  </IfAbility>
</template>;

export default LtiIntegrationsTemplate;
